module.exports = __webpack_public_path__ + "img/duopingtai.c7b46a2f.png";